import { render, staticRenderFns } from "./StoreSettingsPage.vue?vue&type=template&id=6b4dd685&scoped=true"
import script from "./StoreSettingsPage.vue?vue&type=script&lang=js"
export * from "./StoreSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./StoreSettingsPage.vue?vue&type=style&index=0&id=6b4dd685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4dd685",
  null
  
)

export default component.exports